module.exports = __webpack_public_path__ + "img/new_index_cooperate_bg5.12a8b1f8.png";